import { useEffect } from "react";
import useUser from "@auth/useUser";
import { useGetPlansListQuery } from "@/store/services/plans";
import { getPlan, setPlan } from "@/utils/localStorage";

type ApiPlan = {
  id: number;
  nickname: string;
  number_of_applications: number;
  interval: string;
  isCurrentPlan: boolean;
};

function PlanSync() {
  const { data: user, isGuest } = useUser();
  const shouldSyncPlans = !isGuest && user?.role === "Applicant";

  const { data: plansResponse } = useGetPlansListQuery(undefined, {
    skip: !shouldSyncPlans,
  });

  useEffect(() => {
    if (!shouldSyncPlans) {
      return;
    }

    const plans = plansResponse?.data as ApiPlan[] | undefined;
    if (!plans) {
      return;
    }

    const currentPlanFromApi = plans.find((plan) => plan.isCurrentPlan === true);

    if (!currentPlanFromApi) {
      setPlan({});
      return;
    }

    const storedPlan = getPlan();

    setPlan({
      ...(storedPlan && typeof storedPlan === "object" ? storedPlan : {}),
      id: currentPlanFromApi.id,
      name: currentPlanFromApi.nickname,
      interval: currentPlanFromApi.interval,
      number_of_applications: currentPlanFromApi.number_of_applications,
    });
  }, [plansResponse?.data, shouldSyncPlans]);

  return null;
}

export default PlanSync;
